import React from 'react';
import { Check, MessageCircle, ArrowRight } from 'lucide-react';
import { ElectricBorder } from './ElectricBorder';
export function HeroSection() {
  return <section id="hero" className="relative min-h-screen flex items-center pt-20 pb-16 overflow-hidden section-glow" data-id="element-340">
      <div className="max-w-7xl mx-auto px-4 md:px-6 w-full grid grid-cols-1 lg:grid-cols-2 gap-12 items-center relative z-10" data-id="element-341">
        <div className="space-y-8 reveal" data-id="element-342">
          <div className="space-y-4" data-id="element-343">
            <h1 className="text-4xl md:text-6xl font-bold text-white leading-tight" data-id="element-344">
              Website Design Ireland —{' '}
              <span className="gold-gradient-text" data-id="element-345">Done For You</span>
            </h1>
            <p className="text-lg md:text-xl text-white/70 max-w-xl" data-id="element-346">
              Affordable professional websites for Irish small businesses.
              One-time payment, no tech skills needed, fast launch.
            </p>
          </div>

          <ul className="space-y-4" data-id="element-347">
            {['Done-for-you build — no tech skills needed', 'AI editing after launch — 100 monthly requests', '1-year Hobby plan included — $180 value', '1 year of hosting + direct support included'].map((item, i) => <li key={i} className="flex items-start space-x-3" data-id="element-348">
                <div className="mt-1 bg-[#c9a84c]/20 p-1 rounded-full" data-id="element-349">
                  <Check className="w-4 h-4 text-[#c9a84c]" data-id="element-350" />
                </div>
                <span className="text-white/90" data-id="element-351">{item}</span>
              </li>)}
          </ul>

          <div className="flex flex-col sm:flex-row gap-4 pt-4" data-id="element-352">
            <a href="https://wa.me/36707559881?text=Hi%2C%20I%27m%20in%20Dublin.%20I%20want%20the%20%E2%82%AC249%20website%20package.%20My%20business%20is%3A%20____" target="_blank" rel="noopener noreferrer" className="flex items-center justify-center space-x-2 bg-[#25D366] hover:bg-[#20bd5a] text-white px-8 py-4 rounded-lg font-bold text-lg transition-all transform hover:scale-105 shadow-lg shadow-green-900/20" data-id="element-353">
              <MessageCircle className="w-6 h-6" data-id="element-354" />
              <span data-id="element-355">Get Started on WhatsApp</span>
            </a>
            <a href="#contact" className="flex items-center justify-center space-x-2 border border-[#c9a84c] text-[#c9a84c] hover:bg-[#c9a84c]/10 px-8 py-4 rounded-lg font-medium text-lg transition-all" data-id="element-356">
              <span data-id="element-357">Get a Quote</span>
              <ArrowRight className="w-5 h-5" data-id="element-358" />
            </a>
          </div>
          <p className="text-sm text-white/50 ml-2" data-id="element-359">
            ⚡ Fast reply • Typically within 1 hour
          </p>
        </div>

        <div className="relative reveal" data-id="element-360">
          <div className="flex flex-col items-start mb-6 ml-2" data-id="element-361">
            <p className="text-white/60 text-sm italic whitespace-nowrap" data-id="element-362">
              This effect can be used in your webpage
            </p>
            <svg width="40" height="32" viewBox="0 0 40 32" fill="none" xmlns="http://www.w3.org/2000/svg" className="ml-6 mt-1" data-id="element-363">
              <path d="M2 2C2 2 4 14 14 20C20 23.5 28 26 32 28" stroke="rgba(255,255,255,0.45)" strokeWidth="1.2" strokeLinecap="round" fill="none" data-id="element-364" />
              <path d="M28 24L32 28L27 29.5" stroke="rgba(255,255,255,0.45)" strokeWidth="1.2" strokeLinecap="round" strokeLinejoin="round" fill="none" data-id="element-365" />
            </svg>
          </div>

          <ElectricBorder color="#c9a84c" speed={0.8} chaos={0.1} borderRadius={16} data-id="element-366">
            <div className="relative p-8 md:p-10 rounded-xl space-y-8" style={{
            backgroundColor: '#0a0a0a'
          }} data-id="element-367">
              <div className="text-center space-y-2" data-id="element-368">
                <p className="text-[#c9a84c]/80 uppercase tracking-widest text-sm font-medium" data-id="element-369">
                  Dublin Launch Package
                </p>
                <div className="flex items-center justify-center space-x-3" data-id="element-370">
                  <span className="text-2xl text-white/40 line-through" data-id="element-371">
                    €999
                  </span>
                  <span className="text-6xl font-bold text-white" data-id="element-372">€249</span>
                </div>
                <p className="text-[#c9a84c] font-medium" data-id="element-373">
                  All Included • One-time payment
                </p>
                <p className="text-white/50 text-xs pt-1" data-id="element-374">
                  Save over 75% vs agency pricing
                </p>
              </div>

              <div className="border-t border-white/10 pt-6" data-id="element-375">
                <div className="flex items-center justify-between mb-2" data-id="element-376">
                  <span className="text-sm text-white/80" data-id="element-377">
                    Limited Availability
                  </span>
                  <span className="text-sm text-[#c9a84c] font-bold" data-id="element-378">
                    Only a few spots left this month
                  </span>
                </div>
                <div className="flex space-x-2 justify-center" data-id="element-379">
                  {[1, 2].map(i => <div key={i} className="h-2 w-full bg-[#c9a84c] rounded-full" data-id="element-380"></div>)}
                  {[3, 4, 5].map(i => <div key={i} className="h-2 w-full border border-[#c9a84c]/30 rounded-full" data-id="element-381"></div>)}
                </div>
                <p className="text-center text-sm text-white/50 mt-3" data-id="element-382">
                  High demand in Ireland. Secure your spot today.
                </p>
              </div>
            </div>
          </ElectricBorder>

          <p className="text-center text-sm text-white/50 mt-5 italic" data-id="element-383">
            Built with the Irish market in mind 🇮🇪 — proudly working with
            businesses worldwide.
          </p>
        </div>
      </div>
    </section>;
}